import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IPremiumComparison } from "./premiumComparison.types";
import { generateAdvanceFilterQuery } from "../Accounting/AccountingReports/AccountingReportsActions";

export const CLEAR_PREMIUM_COMPARISON_STATE = "CLEAR_PREMIUM_COMPARISON_STATE";
export const clearPremiumComparisonState = () =>
  action(CLEAR_PREMIUM_COMPARISON_STATE);

export const FETCH_PREMIUM_COMPARISON_LIST_PROGRESS =
  "FETCH_TASK_RENEWALS_LIST_PROGRESS";
export const FETCH_PREMIUM_COMPARISON_LIST_SUCCESS =
  "FETCH_TASK_RENEWALS_LIST_SUCCESS";
export const FETCH_PREMIUM_COMPARISON_LIST_FAILED =
  "FETCH_TASK_RENEWALS_LIST_FAILED";

export const fetchPremiumComparisonListProgress = () =>
  action(FETCH_PREMIUM_COMPARISON_LIST_PROGRESS);
export const fetchPremiumComparisonListSuccess = (
  list: IPremiumComparison[],
  totalRecords: number,
) => action(FETCH_PREMIUM_COMPARISON_LIST_SUCCESS, { list, totalRecords });
export const fetchPremiumComparisonListFailed = () =>
  action(FETCH_PREMIUM_COMPARISON_LIST_FAILED);

export const fetchPremiumComparisonListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,

    searchValue: IDatatableV2AdvancedSearchFilter,

    groupType: string,
    searchState: { [key: string]: any },
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { from_date, to_date, customer_policy_id, ...finalSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(finalSearchState);
      dispatch(fetchPremiumComparisonListProgress());
      let finalUrl = `/accounting/generate-premium-report?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}`;

      if (searchValue.length > 0) {
        finalUrl = finalUrl + `&advanceFilter=${JSON.stringify(searchValue)}`;
      }

      if (status !== "-1") {
        finalUrl = finalUrl + `&column=${"policy_status"}&value=${status}`;
      }
      if (groupType !== "-1") {
        finalUrl += "&group_of=" + groupType;
      }
      if (query) {
        finalUrl = finalUrl + "&" + query;
      }
      const res = await api.get(finalUrl);

      const data: IPremiumComparison[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchPremiumComparisonListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchPremiumComparisonListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const downloadPremiumComparisonPDFAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    selectedDayValue: string,
    status: string,
    groupType: string,
    searchState: { [key: string]: any },
    onCallback: () => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { from_date, to_date, customer_policy_id, ...finalSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(finalSearchState);
      let finalUrl = `/policy/get-all-customer-renewal-details-pdf?from_date=${from_date}&to_date=${to_date}`;

      if (query) {
        finalUrl += "&" + query;
      }

      if (selectedDayValue) {
        finalUrl = finalUrl + "&date_column=create_ts";
      }
      if (status !== "-1") {
        finalUrl = finalUrl + `&column=${"policy_status"}&value=${status}`;
      }
      if (groupType !== "-1") {
        finalUrl += "&group_of=" + groupType;
      }
      const res = await api.get(finalUrl, {
        responseType: "arraybuffer",
      });

      const pdfBuffer = res.data;

      const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "Renewals.pdf";
      link.click();

      URL.revokeObjectURL(pdfUrl);
      onCallback();
    } catch (err: any) {
      // dispatch(fetchAutomobileOcep17Failed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
